import { RebateRelease } from '@core/models/rebate-release-model';
import { tap, map } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class NewRebateReleaseDataService extends DefaultDataService<RebateRelease>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();
  data$ = new Subject<any[]>();

  currentPageTotal = 0;
  totalAmount = 0;
  totalTurnover=0;
  subtotalTurnover=0;
  totalWL=0;
  subtotalWL=0;

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('NewRebateRelease', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<RebateRelease[]> {
    return this.http.get<ApiResponse>(`/rebaterelease${pageParam}`).pipe(
      tap(res => {
        this.paginationInit(res);
        this.currentPageTotal = res.data.current_page_total;
        this.totalAmount = res.data.total_amount;
      }),
      map(res => res.data.rows)
    );
  }

  generateRebate(data: any) {
    return this.http.post<ApiResponse>(`/rebaterelease/generatenew`, data).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  release(data: any) {
    return this.http.post<ApiResponse>(`/rebaterelease/release`, data).pipe(
      tap(res => {
        this.messages$.next(res.message);
        // For duplicate records
        this.data$.next(res.data);
      })
    );
  }

  reject(data: any) {
    return this.http.post<ApiResponse>(`/rebaterelease/reject`, data).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }
  
  updateRebate(data: any) {
    return this.http.post<ApiResponse>(`/rebaterelease/updaterebate`, data).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  showRebateDetails(id: number) {
    return this.http.get<ApiResponse>(`/rebaterelease/${id}`).pipe(
      map(res => res.data.rows)
    );
  }

  
  showPromotionTurnoverDetails(pageParam: string, id: number) {
    return this.http.get<ApiResponse>(`/rebaterelease/promoturnover/detail/${id}${pageParam}`).pipe(
      tap(res => {
        this.paginationInit(res);
        this.totalTurnover = res.data.total_turnover;
        this.subtotalTurnover = res.data.subtotal_turnover;
        this.totalWL = res.data.total_winlose;
        this.subtotalWL = res.data.subtotal_winlose;
      }),
      map(res => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
